import { Outlet, useLocation } from 'react-router';

import { FullPageLoader } from '@/shared/components/FullPageLoader';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { Navigate } from 'react-router';

import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { Toaster } from '@/shared/components/Toaster';
import { MobileTabBar } from './MobileTabBar';

/**
 * The authenticated frame. Desktop: sidebar on the left. Mobile: tab bar at
 * the bottom with up to 3 primary items + a "More" overflow menu.
 */
export function AppShell() {
  const { user, isAuthenticated, isRestoring } = useAuth();
  const location = useLocation();

  if (isRestoring) return <FullPageLoader />;
  if (!isAuthenticated) return <Navigate to="/ingresar" replace state={{ from: location }} />;

  // A temporary password (or an HR reset) forces the change before anything
  // else can be reached — the change page is the only screen allowed.
  if (user?.must_change_password && location.pathname !== '/cambiar-contrasena') {
    return <Navigate to="/cambiar-contrasena" replace />;
  }

  return (
    <div className="flex min-h-screen">
      <Sidebar />

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />

        <main className="min-w-0 flex-1 p-4 pb-20 md:p-6 print:p-0">
          {/* Keyed on the path so navigating away clears a caught error
              instead of stranding the user on the fallback. */}
          <ErrorBoundary resetKey={location.pathname}>
            <Outlet />
          </ErrorBoundary>
        </main>

        <Toaster />
      </div>

      <MobileTabBar />
    </div>
  );
}
